/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuayData
 */
export interface QuayData {
    /**
     * 
     * @type {number}
     * @memberof QuayData
     */
    priority?: number;
}

/**
 * Check if a given object implements the QuayData interface.
 */
export function instanceOfQuayData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function QuayDataFromJSON(json: any): QuayData {
    return QuayDataFromJSONTyped(json, false);
}

export function QuayDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuayData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
    };
}

export function QuayDataToJSON(value?: QuayData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'priority': value.priority,
    };
}

